import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("groot_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Çoklu firma girişi: seçili firma (tenant) bağlamını TÜM isteklere ekle → istek doğru firmanın izole DB'sine gider.
  try {
    const tenant = localStorage.getItem("groot_tenant");
    if (tenant) config.headers["X-Tenant"] = tenant;
  } catch (e) {}
  // Aktif sektör bağlamını TÜM GET isteklerine otomatik ekle — katalog/fiyat uçları buna göre süzülür.
  // Boş/"full"/"__all__" → filtre yok (tüm sektörler). URL veya params'ta sector zaten varsa dokunma.
  try {
    const method = (config.method || "get").toLowerCase();
    const sec = localStorage.getItem("groot_sector") || "";
    const urlHasSector = /[?&]sector=/.test(config.url || "");
    const paramsHasSector = config.params && config.params.sector != null;
    if (method === "get" && sec && sec !== "full" && sec !== "__all__" && !urlHasSector && !paramsHasSector) {
      config.params = { ...(config.params || {}), sector: sec };
    }
  } catch (e) {}
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const { response, config } = err;
    // /auth/step-up 401'i "yanlış şifre" demektir (oturum sona ermesi DEĞİL) → çıkış yaptırma
    if (response?.status === 401 && !window.location.pathname.includes("login") && !(config?.url || "").includes("/auth/step-up")) {
      localStorage.removeItem("groot_token");
      window.location.href = "/login";
      return Promise.reject(err);
    }
    // 429 → (ingress/proxy) hız sınırı: kısa artan bekleme ile otomatik yeniden dene
    // (aynı anda çok istek atan sayfalar — ör. /ayarlar — ilk boyamada sessizce boş kalmasın).
    if (response?.status === 429 && config && (config.__retry429 || 0) < 3) {
      config.__retry429 = (config.__retry429 || 0) + 1;
      await new Promise((res) => setTimeout(res, 350 * config.__retry429 + Math.random() * 300));
      return api(config);
    }
    // 428 → kritik işlem için kimlik teyidi (step-up) gerekli: doğrula ve isteği tekrarla
    if (response?.status === 428 && config && !config.__stepUpRetried && _stepUpHandler) {
      config.__stepUpRetried = true;
      try {
        const token = await _stepUpHandler(apiError(response.data?.detail) || "Bu işlem");
        config.headers = { ...(config.headers || {}), "X-Step-Up": token };
        return api(config);
      } catch (e) {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

let _stepUpHandler = null;
export function setStepUpHandler(fn) { _stepUpHandler = fn; }

export function apiError(detail) {
  if (detail == null) return "Bir hata oluştu.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
